module.exports = __webpack_public_path__ + "img/POP-00012-3.f0915c3f.png";